import {useForm} from '@inertiajs/react';
import React, {FormEventHandler, useEffect} from 'react';
import {UserSettings} from '@/types';
import toast from "react-hot-toast";
import SettingRow from "@/Pages/Settings/Partials/SettingRow";

const toastId = 'settings-update';

export default function UpdateSettingsForm({settings}: {
    settings: UserSettings
}) {
    const {data, setData, patch, isDirty} = useForm(
        settings
    );

    useEffect(() => {
        if(isDirty) {
            save()
        }
    }, [isDirty]);

    const save = () => {
        patch(route('setting.update'), {
            onStart: () => toast.loading('Saving...', { id: toastId }),
            onSuccess: () => toast.success('Settings updated successfully.', { id: toastId }),
            onError: (error) => toast.error(`Failed to update settings: ${error.message}`, { id: toastId }),
            preserveScroll: true,
            preserveState: true,
            showProgress: false
        })
    }

    const submit: FormEventHandler = (e) => {
        e.preventDefault();
        patch(route('setting.update'));
    };

    return (
        <section>
            <form onSubmit={submit} className="px-1 md:px-5 pb-3">

                <SettingRow
                    id="download-complete"
                    title="Download subtitles when extraction completes"
                    description="Automatically download the subtitles when the extraction completes."
                    value={data.downloadOnComplete}
                    onChange={(value) => setData('downloadOnComplete', value)}
                />

                <SettingRow
                    id="ignore-softcoded"
                    title="Prefer hardcoded subtitles by default"
                    description="For vision-based extraction, ignore embedded subtitle tracks and extract text directly from video frames instead. This setting can be changed for individual uploads."
                    value={data.ignoreSoftcodedSubtitles}
                    onChange={(value) => setData('ignoreSoftcodedSubtitles', value)}
                />

                <SettingRow
                    id="auto-submit"
                    title="Auto-start extraction"
                    description="Automatically start extraction after uploads complete, without requiring a manual submit click. This setting can still be changed for individual uploads."
                    value={data.autoSubmitExtraction}
                    onChange={(value) => setData('autoSubmitExtraction', value)}
                    isLast={true}
                />


            </form>
        </section>
    );
}
